var exports = {
  "a": "emboldened__K6tz9i",
};

module.exports = exports;
